import { ReminderEntityTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";
import type { ReminderEntity } from "web_myplann/Reminders/Types/ReminderTypes";

export const getReminderEntity = (
	itemKind: PortfolioItemKind,
	id: number,
): ReminderEntity => ({
	type:
		itemKind === PortfolioItemKind.Property
			? ReminderEntityTypeEnum.Property
			: ReminderEntityTypeEnum.Portfolio,
	id,
});
